
import React from 'react';
import SwitchOffIcon from 'src/icons/SwitchOffIcon';
import SwitchOnIcon from 'src/icons/SwitchOnIcon';
import CheckedCheckboxIcon from 'src/icons/CheckedCheckbox';
import CheckboxIcon from 'src/icons/Checkbox';

export default function KeymastersPotCheckbox({ onClick, className, isSelected, variation = 'regular' | 'keymaster', disabled }) {

	const icons = {
		keymaster:{
			off:<SwitchOffIcon/>,
			on: <SwitchOnIcon/>,
		},
		regular:{
			off:<CheckboxIcon/>,
			on: <CheckedCheckboxIcon/>,
		},
	};

	return ( <label
		className={`relative cursor-pointer mr-2 ${className}`}>
		<input
			onClick={onClick && onClick}
			type="checkbox"
			disabled={disabled}
			className='absolute left-0 top-0 w-full h-full hidden' />
		{!isSelected && ( icons[variation].off ?? icons.regular.off )}
		{isSelected && ( icons[variation].on ?? icons.regular.on )}
	</label> );
}
